/**
 * Hard navigation for public route recovery (stale chunk / lazy import).
 * First attempt: same pathname, full document load (drops stale query/hash).
 * Later attempts: cache-busting `r` query param.
 */
export function performPublicRouteHardRefresh(): void {
  const path = window.location.pathname;
  const key = `xo.pr.hard:${path}`;
  const n = Number(sessionStorage.getItem(key) ?? "0");
  if (n === 0) {
    sessionStorage.setItem(key, "1");
    window.location.assign(path);
    return;
  }
  sessionStorage.setItem(key, String(n + 1));
  window.location.assign(`${path}?r=${Date.now()}`);
}
